import { createRouter, createWebHistory } from 'vue-router'
import LoginView from '@/views/LoginView.vue'

import DashboardView from '@/views/DashboardView.vue'
import AcercaView from '@/views/AcercaView.vue'
import UsuariosView from '@/views/UsuariosView.vue'
import ArmasView from '@/views/ArmasView.vue'
import AdminView from '@/views/AdminView.vue'
import CertificacionesView from '@/views/CertificacionesView.vue'
import CertificadosView from '@/views/CertificadosView.vue'
import MunicionView from '@/views/MunicionView.vue'
import RegistroView from '@/views/RegistroView.vue'
import EjercitoView from '@/views/EjercitoView.vue'
import AereaView from '@/views/AereaView.vue'
import ArmadaView from '@/views/ArmadaView.vue'
import ClasarmasView from '@/views/ClasarmasView.vue'
import BayonetaView from '@/views/BayonetaView.vue'
import ArmamentoView from '@/views/ArmamentoView.vue'
//import MiVista from '@/views/MiVista.vue'

import RegistroArmaIndividual from '@/views/RegistroArmaIndividualView.vue'
import RegistroArmas from '@/views/RegistroArmasView.vue'
import RegistroArmasFuego from '@/views/arma_fuego/RegistroArmasFuegoView.vue'
import RegistroCuchillo from '@/views/cuchillo_dotacion/RegistroCuchilloView.vue'
import RegistroSable from '@/views/sable_dotacion/RegistroSableView.vue'
import Select from '@/views/SelectView.vue'
import DotacionGeneral from '@/views/DotacionGeneralView.vue'
import LoginpView from '@/views/LoginpView.vue'
import DotacionindividualView from '@/views/DotacionindividualView.vue'
import Cuchillos from '@/views/ResarcimientoCuchilloView.vue'
import Pistolas from '@/views/ResarcimientoPistolaView.vue'
import Sables from '@/views/ResarcimientoSableView.vue'
//reportes
import ReporteArmas from '@/views/ReporteArmasView.vue'
//Reposiciones
import ReposicionCuchillo from '@/views/reposiciones/CuchilloReposicionView.vue'
import ReposicionCuchilloEjercito from '@/views/reposiciones/ReposicionCuchilloEjercitoView.vue'
import ReposicionCuchilloAerea from '@/views/reposiciones/ReposicionCuchilloAereaView.vue'
import ReposicionCuchilloArmada from '@/views/reposiciones/ReposicionCuchilloArmadaView.vue'

//Resarcimientos
import ResarcimientoEjercitoGet from '@/views/resarcimientos/ResarcimientoEjercitoGetView.vue'//EJERCITO
import AereaGet from '@/views/resarcimientos/AereaGetView.vue'//AEREA
import ArmadaGet from '@/views/resarcimientos/ArmadaGetView.vue'//EJERCITO

import ResarcimientosView from '@/views/resarcimientos/ResarcimientoView.vue'
import ResarcimientoEjercito from '@/views/resarcimientos/ResarcimientoEjercitoView.vue'//EJERCITO
import ResarcimientoAerea from '@/views/resarcimientos/ResarcimientoAereaView.vue'//AEREA
import ResarcimientoArmada from '@/views/resarcimientos/ResarcimientoArmadaView.vue'//AEREA

import CertificadosResarcimientoEjercitoGet from '@/views/certificados/CertificadosResarcimientosEjercitoView.vue'
import CertificadosResarcimientoAereaGet from '@/views/certificados/CertificadosResarcimientosAereaView.vue'
import CertificadosResarcimientoArmadaGet from '@/views/certificados/CertificadosResarcimientosArmadaView.vue'
//REPORTES
import RegistroDotacionArma from '@/views/RegistroDotacionArmaView.vue'
import RegistroResarcimientos from '@/views/Reportes/ReporteResarcimientosView.vue'
import RegistroReposiciones from '@/views/Reportes/ReporteReposicionesView.vue'
import RegistroPistolaGradoFuerza from '@/views/Reportes/ReportePistolaFuerzaView.vue'
import RegistroCuchilloGradoFuerza from '@/views/Reportes/ReporteCuchilloFuerzaView.vue'
import RegistroSablesGradoFuerza from '@/views/Reportes/ReporteSablesFuerzaView.vue'
import ReporteFechas from '@/views/Reportes/ReporteFechasView.vue'


import organico from '@/views/OrganicoView.vue'
//MASIVO
import RegistroMasivo from '@/views/dotacion/RegistroDotacionView.vue'

//FIN DE REPORTES
const routes = [
   //IMPORTAR
   {
    //path: '/TbwUQ0/07wsAO1dQt6X8LqEucE8RtcPawYgHDzchxEePkM/p7Qw3IHlCmC1hntWKmC6wy4PeKWrmLZHTTHFqbw',//PERSONAL MILITAR
    path: '/registro/registromasivo',
    name: 'registrodotacionmasivo',
    //name: encryptRoute('registrodotacionmasivo'),
    component: RegistroMasivo,
    meta: {
      requiresAuth: true
    }
  },
    //Organico
    {
      path: '/organico',
      name: 'organico',
      component: organico,
    },
    
  //REPORTES
  {
    path: '/reportes/repfechas',
    name: 'repfechas',
    component: ReporteFechas,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/registrodotacionarma', //PERSONAL MILITAR
    name: 'registrodotacionarma',
    component: RegistroDotacionArma,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/reportes/reportesresarcimientos',//RESARCIMIENTOS
    name: 'reportesresarciminetos',
    component: RegistroResarcimientos,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/reportes/reportesreposiciones',//REPOSiCIONES
    name: 'reportesreposiciones',
    component: RegistroReposiciones,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/reportes/reportedotacionpistola',//PISTOLA
    name: 'reportespistolafuerza',
    component: RegistroPistolaGradoFuerza,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/reportes/reportedotacioncuchillo',//cuchillo
    name: 'reportescuchillofuerza',
    component: RegistroCuchilloGradoFuerza,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/reportes/reportedotacionsables',//cuchillo
    name: 'reportessablesfuerza',
    component: RegistroSablesGradoFuerza,
    meta: {
      requiresAuth: true
    }
  },
  //FIN REPORTES
  //EJERCITO
  {
    path: '/resarcimientoejercitoget',
    name: 'resarcimientoejercitoget',
    component: ResarcimientoEjercitoGet,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/resarcimientoejercito',
    name: 'resarcimientoejercito',
    component: ResarcimientoEjercito,
  },
  {
    path: '/reposicioncuchilloejercito',
    name: 'reposicioncuchilloejercito',
    component: ReposicionCuchilloEjercito,
  },
  //CERTIFICADOS EJERCITO
  {
    path: '/certificados/getcertificados',
    name: 'certificadoresarcimientoejercitoget',
    component: CertificadosResarcimientoEjercitoGet,
  },
  //*AEREA
  {
    path: '/resarcimientoaereaget',
    name: 'resarcimientoaereaget',
    component: AereaGet,
  },
  //AEREA
  {
    path: '/resarcimientoaerea',
    name: 'resarcimientoaerea',
    component: ResarcimientoAerea,
  },
  {
    path: '/reposicioncuchilloaerea',
    name: 'reposicioncuchilloaerea',
    component: ReposicionCuchilloAerea,
  },
  //CERTIFICADOS AEREA
  {
    path: '/certificados/getcertificadosaerea',
    name: 'certificadoresarcimientoaereaget',
    component: CertificadosResarcimientoAereaGet,
  },
  //ARMADA
  {
    path: '/resarcimientoarmadaget',
    name: 'resarcimientoarmadaget',
    component: ArmadaGet,
  },
  {
    path: '/resarcimientoarmada',
    name: 'resarcimientoarmada',
    component: ResarcimientoArmada,
  },
  {
    path: '/certificados/getcertificadosarmada',
    name: 'certificadoresarcimientoarmadaget',
    component: CertificadosResarcimientoArmadaGet,
  },

  {
    path: '/resarcimientos',
    name: 'resarcimientos',
    component: ResarcimientosView,
    meta: {
      requiresAuth: true
    }
  },
  //reposiciones
  {
    path: '/reposicioncuchilloarmada',
    name: 'reposicioncuchilloarmada',
    component: ReposicionCuchilloArmada,
  },


  {
    path: '/reposicioncuchillo',
    name: 'reposicioncuchillo',
    component: ReposicionCuchillo
  },
  {
    path: '/reportearmasejercito',
    name: 'reportearmasejercito',
    component: ReporteArmas
  },
  {
    path: '/reportearmasaerea',
    name: 'reportearmasaerea',
    component: ReporteArmas
  },
  {
    path: '/reportearmasarmada',
    name: 'reportearmasarmada',
    component: ReporteArmas
  },
  {
    path: '/',
    name: 'login',
    component: LoginView
  },
  {
    path: '/dotacion',
    name: 'dotacion',
    component: DotacionindividualView
  },
  {
    path: '/loginp',
    name: 'loginp',
    component: LoginpView
  },
  {
    path: '/pistolas',
    name: 'pistolas',
    component: Pistolas
  },
  {
    path: '/sables',
    name: 'sables',
    component: Sables
  },
  {
    path: '/cuchillos',
    name: 'cuchillos',
    component: Cuchillos
  },
  {
    path: '/dashboard',
    name: 'dashboard',
    component: DashboardView,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/acerca',
    name: 'acerca',
    component: AcercaView,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/usuarios',
    name: 'usuarios',
    component: UsuariosView,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/armas',
    name: 'armas',
    component: ArmasView,
    meta: {
      requiresAuth: true
    }
  },

  {
    path: '/registroarmaindividual',
    name: 'registroarmaindividual',
    component: RegistroArmaIndividual,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/registroarmas',
    name: 'registroarmas',
    component: RegistroArmas,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/registroarmasfuego',
    name: 'registroarmasfuego',
    component: RegistroArmasFuego,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/registrocuchillos',
    name: 'registrocuchillos',
    component: RegistroCuchillo,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/registrosables',
    name: 'registrosables',
    component: RegistroSable,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/selectexample',
    name: 'selectexample',
    component: Select,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/dotaciongeneral',
    name: 'dotaciongeneral',
    component: DotacionGeneral,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/certificados',
    name: 'certificados',
    component: CertificadosView,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/admin',
    name: 'admin',
    component: AdminView,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/certificaciones',
    name: 'certificaciones',
    component: CertificacionesView,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/municion',
    name: 'municion',
    component: MunicionView,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/registro',
    name: 'registro',
    component: RegistroView,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/ejercito',
    name: 'ejercito',
    component: EjercitoView,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/aerea',
    name: 'aerea',
    component: AereaView,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/armada',
    name: 'armada',
    component: ArmadaView,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/clarmas',
    name: 'clarmas',
    component: ClasarmasView,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/bayoneta',
    name: 'bayoneta',
    component: BayonetaView,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/armamento',
    name: 'armamento',
    component: ArmamentoView,
    meta: {
      requiresAuth: true
    }
  },
  //{
  //  path: '/',
  //  name: 'inicio',
  //  component: MiVista
  //},
  {
    path: '/bienvenido',
    name: 'bienvenido',
    component: () => import(/* webpackChunkName: "about" */ '@/views/BienvenidoView.vue'),
  }

]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router